app.service('finalizeView', function (console, loading, orderUtils, orderConfig, modal, ePaymentBlikModal, ePaymentModal) {
	var $self;
	var config, toEPaymentTimeCount, orderNumber, type, timeoutId, prefix, instalmentNumber, kredytLine;

	function setElements() {
		prefix = "";
		$self = $('#finalize #container');
		config = orderConfig.getData();
		orderNumber = config.orderNumber;
		kredytLine = config.kredytLine;
		instalmentNumber = config.instalmentNumber;
		type = config.ePaymentType;
		toEPaymentTimeCount = config.toEPaymentTimeCount; // czas odliczania
		if (config.kredytLineTimeCount) {
			toKredytLineTimeCount = config.kredytLineTimeCount;
		}
		UA.push({
			positions: config.pluQuantity,
			products: config.productsQuantity
		});
	}

	function setEvents() {
		$('.js-manual-payment-btn').click(function (event) {
			modal.close('EPayment');
			ePaymentModalLoad();
		});

		$('.js-payment-operator-blik-btn').on('click', function () {
			modal.open('EPayment-operator-blik');
		});
		
		$("#operator-blik-payment").click(function () {
			modal.close('EPayment-operator-blik');
			choosePaymentToLoad();
		});

		$("#operator-blik-cancel").click(function () {
			modal.close('EPayment-operator-blik');
		});

		$('.js-payment-blik-btn').on('click', function () {
			choosePaymentToLoad();
		});

		$(document).on('closing', '#modal-EPayment, #modal-kredytLine-count', function () {
			stopCountingAutomaticRedirect(); // na zmkniecie modala - przerwac odliczanie!
		});

		$(".js-open-instalmentLayer-modal").click(function () {
			ePaymentModal.goToInstalment(orderNumber, instalmentNumber);
		});

		$('.js-trade-doubler').on('load', function () {
			tradeDoublerConfirm();
		});
	}

	function choosePaymentToLoad(){
		if (config.ePaymentType == 'PaymentModule') {
			ePaymentModalLoad();
		} else {
			ePaymentBlikModal.load(config.ePaymentType, config.orderNumber);
		}
	}

	function tradeDoublerConfirm() {
		$.ajax({
			type: "GET",
			url: '/order-path-trade-doubler-confirm.ltr',
			data: {
				orderNumber: config.orderNumber
			}
		});
	}

	function showKredytLineMessage() {
		modal.open('kredytLine-count');
		setKredytLineTimeoutToClose();
	}

	function showEPaymentMessage() {

		modal.open('EPayment');

		setEPaymentTimeoutToClose(); // funkcja odliczajaca czas do zamkniecia
		$("#go-to-payment-site").click(function () {
			modal.close('EPayment');
			ePaymentModalLoad();
		});
	}

	function showEPaymentOperatorBlik () {
		modal.open('EPayment-operator-blik');
	}

	function ePaymentModalLoad() {
		ePaymentModal.load({
			type: config.ePaymentType,
			orderNumber: config.orderNumber
		});
	}

	function setEPaymentTimeoutToClose() {
		toEPaymentTimeCount--; console.log("odliczam" + toEPaymentTimeCount);
		var text = 'Płacę';
		if (toEPaymentTimeCount === 0) {
			modal.close('EPayment');
			ePaymentModalLoad();
			$('#modal-EPayment a').text(text);
		}
		else {
			$('#modal-EPayment a').text(text + ' (' + toEPaymentTimeCount + ')');
			timeoutId = setTimeout(function () {
				setEPaymentTimeoutToClose();
			}, 1000);
		}
	}

	function setKredytLineTimeoutToClose() {
		toKredytLineTimeCount--;
		if (toKredytLineTimeCount === 0) {
			gotoKredytLine();
		}
		else {
			timeoutId = setTimeout(function () {
				setKredytLineTimeoutToClose();
			}, 1000);
		}
	}

	function gotoKredytLine() {
		ePaymentModal.goToInstalment(orderNumber, instalmentNumber);
	}

	function stopCountingAutomaticRedirect() {
		clearTimeout(timeoutId);
	}

	function showCardSubscriptionEncouragement() {
		$.ajax({
			type: "GET",
			url: '/order-path-card-subscription-encouragement.ltr',
			success: function (html) {
				modal.generate({
					id: 'card-subscription-encouragement',
					close: true,
					content: html,
				});
				$('#encouragement-description-toggler').click(function () {
					$('#js-encouragement-description').toggleClass('is-full');
					if ($('#js-encouragement-description').hasClass('is-full')) {
						UA.interaction('PG', 'Abonament', 'Co warto wiedziec')
					}
				});
				$('#card-subscription-encouragement .remodal-close').click(function () {
					UA.interaction('PG', 'Abonament', 'Zrob to pozniej');
				})
				$('.js-subscribe-card').click(function subscribeCard() {
					UA.interaction('PG', 'Abonament', 'Dodaj karte')
					loading.start();
					$.ajax({
						method: 'POST',
						url: '/card-subscription-transaction-payment-url.ltr',
						data: {
							orderNumber: config.orderNumber
						}
					}).then(response => {
						if (response.status === 'FAIL') {
							loading.stop();
							modal.alert(response.messages.join(''));
						} else {
							loading.redirect(response.transactionPaymentUrl);
						}
					}).fail(() => {
						loading.stop();
						modal.alert("Wystąpiły problemy techniczne. Spróbuj dodać kartę w koncie klienta lub skontaktuj się z działem pomocy.");
					});
				});
			},
			error: function () {
				modal.alert('Wystąpiły problemy techniczne. Spróbuj dodać kartę w koncie klienta lub skontaktuj się z działem pomocy.');
			}
		});
	}
	function showMessageIfNeeded() {
		if (config.showCardSubscriptionEncouragement) {
			showCardSubscriptionEncouragement();
		} else if (config.ePaymentType && config.toEPaymentTimeCount) {
			if (config.isOperatorMode === true) {
				showEPaymentOperatorBlik();
			}else if (config.ePaymentBlik) {
				ePaymentBlikModal.load(config.ePaymentType, config.orderNumber);
			} else {
				showEPaymentMessage();
			}
		} else if (config.kredytLine && config.kredytLineTimeCount) {
			showKredytLineMessage();
		}
	}

	function init() {
		setElements();
		ePaymentBlikModal.init();
		setEvents();
		if (config.showPopupAfterBuyingMessage) {
			modal.open('after-buying-message');
			$(document).on('closed', '#modal-after-buying-message', function () {
				showMessageIfNeeded();
			});
		} else {
			showMessageIfNeeded();
		}
	}
	return {
		init: init
	};
});
